<template>
    <div class="EvolutionBilan">
        <HeadPage :title="'Bilan de compétences'" 
                  :category="'Evolution professionnelle'"
                  :img="'evolution/bilan.jpg'"
                  :imgAlt="'Bilan head page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "EvolutionBilan",
    data() {
        return {
            content: [
                { 
                    text: [ `Le bilan de compétences est <strong>un outil d'évolution professionnelle.</strong>`,
                    `Il s'adresse aux personnes en questionnement sur leur devenir professionnel et permet de :`,
                    `<ul>
                        <li>Faire le point sur son parcours professionnel et personnel</li>
                        <li>Explorer ses possibilités d'évolution</li>
                        <li>Anticiper les obstacles au changement</li>
                        <li>Élaborer un projet professionnel et/ou de formation réaliste</li>
                        <li>Définir une stratégie d'action</li>
                    </ul>`,
                    `La durée d'un bilan de compétences est de 24 heures, réparties sur 6 à 8 semaines et alterne des phases 
                    d'entretiens individuels, de travail personnel et de rencontres avec des professionnels. Un suivi est proposé dans les 6 mois qui 
                    suivent la prestation.`,
                    `Les consultants(es) <strong>JobStream</strong> proposent un accompagnement qui valorise les personnes en les aidant 
                    à repérer les points d'appui pour construire leur projet. Ils se conforment aux règles de déontologie et 
                    de confidentialité en s'attachant à favoriser des pratiques qui mettent les personnes en situation d'acteur pour leur 
                    devenir professionnel.`,
                    `Un appui au montage du dossier de financement est également proposé.`
                        ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>